import { render, staticRenderFns } from "./TicketsViewTable.vue?vue&type=template&id=6284af4c&lang=pug&"
import script from "./TicketsViewTable.vue?vue&type=script&lang=js&"
export * from "./TicketsViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports